"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : SWITCH : STYLES--------------- ++++++++++ */


var _default = {
  switch: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: (0, _index.pxToEm)(4),
    borderRadius: (0, _index.pxToEm)(100),
    cursor: 'pointer',
    width: (0, _index.pxToEm)(78),
    height: (0, _index.pxToEm)(42),
    transition: 'all .05s ease-in-out .05s',
    '& .ball': {
      height: (0, _index.pxToEm)(34),
      width: (0, _index.pxToEm)(34),
      borderRadius: 50,
      background: _index.theme.color.light.light.swatch,
      position: 'absolute',
      left: (0, _index.pxToEm)(4),
      transition: 'all .05s ease-in-out .05s'
    },
    '&.active-true': {
      '& .ball': {
        left: '50%'
      },
      '&.variant-primary': {
        background: _index.theme.color.primary.medium.swatch
      },
      '&.variant-secondary': {
        background: _index.theme.color.secondary.medium.swatch
      }
    },
    '&.active-false': {
      '&.variant-primary': {
        background: _index.theme.color.neutral.light.swatch
      },
      '&.variant-secondary': {
        background: _index.theme.color.attention.medium.swatch
      }
    }
  }
};
exports.default = _default;